import types from "../types/types";

const initialState = {
  shifts: undefined,
  loaded: false,
};

const shiftsReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.SET_SHIFTS:
      return {
        ...state,
        shifts: Array.isArray(payload) ? payload : [],
        loaded: true,
      };
    default:
      return state;
  }
};

export default shiftsReducer;
